export function formatNumber(num) {
  const [integer, decimal] = num.toString().split(".");
  const formattedInt = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return decimal ? `${formattedInt}.${decimal}` : formattedInt;
}

export const formatToFixedTwo = (num: string) => {
  return Number(num).toFixed(2);
};

export const formatPhoneNumber = (e) => {
  const inputValue = e.target.value;
  const digits = inputValue.replace(/[^\d]/g, "");
  let formattedNumber = "";
  if (digits.length > 0) {
    formattedNumber = "(" + digits.slice(0, 3);
  }
  if (digits.length >= 4) {
    formattedNumber += ") " + digits.slice(3, 6);
  }
  if (digits.length >= 7) {
    formattedNumber += " - " + digits.slice(6, 10);
  }
  return formattedNumber;
};
